import { $ } from '@zimpa/dom';
import { Modal } from './modal';

const TRIGGER_CLASS = 'js-modal-trigger';

import Handlebars from 'handlebars/dist/cjs/handlebars'

export function handle(el: HTMLElement): void {
    const data = JSON.parse(<string>el.getAttribute('data-modal'));
    const tpl = $(<string>el.getAttribute('data-modal-template-selector'));

    if (tpl === undefined) {
        return;
    }

    const template = Handlebars.compile(tpl.innerHTML);
    const content = template(data);

    Modal.open(content);
    el.dispatchEvent(new CustomEvent('ModalOpen'));
}

export function trigger(): void {
    document.body.addEventListener('click', (event: MouseEvent): void => {
        if (
            event.target &&
            (<HTMLElement>event.target).classList.contains(TRIGGER_CLASS)
        ) {
            handle(<HTMLElement>event.target);
        }
    });
}
